/**
 * Signup-source labels shared with website-api `labelSignupSource`.
 *
 * The API returns display labels (e.g. "Google Ads", "Hibu (Google Ads)").
 * A raw `hibu` bucket (API before the Hibu rule) is shown under the same label.
 */

export const HIBU_SOURCE_LABEL = 'Hibu (Google Ads)';

/** Hibu ad links carry ?cam=ppc-…; add Display prefixes here when Hibu shares them. */
export const HIBU_CAM_PREFIXES = Object.freeze(['ppc-']);

function lowerTrim(value) {
  if (value == null) return '';
  return String(value).trim().toLowerCase();
}

/** Same rule as website-api classifyHibuSource: utm_source=hibu or cam starts with ppc-. */
export function isHibuSignup({ utmSource, cam } = {}) {
  if (lowerTrim(utmSource) === 'hibu') return true;
  const camText = lowerTrim(cam);
  return Boolean(camText) && HIBU_CAM_PREFIXES.some((prefix) => camText.startsWith(prefix));
}

export function displaySignupSource(source) {
  if (lowerTrim(source) === 'hibu') return HIBU_SOURCE_LABEL;
  return source;
}

/** Map labels and merge rows that land in the same bucket. Keeps API order. */
export function normalizeSignupSourceRows(rows) {
  const merged = new Map();
  for (const row of rows || []) {
    if (!row?.source) continue;
    const source = displaySignupSource(row.source);
    const prior = merged.get(source);
    if (prior) {
      prior.count = (Number(prior.count) || 0) + (Number(row.count) || 0);
    } else {
      merged.set(source, { ...row, source });
    }
  }
  return [...merged.values()];
}
